import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import { generateIcon } from "utils";
import { useMediaContext } from "../../../context/MediaContext";

interface ISelectableItemProps {
  children: React.ReactNode;
  id: string;
  isSelectable?: boolean;
  getSelect?: (id: string) => boolean;
  selectedElements?: string[];
  handleSelect?: () => void;
}

export default function SelectableItem({
  children,
  id,
  isSelectable = true,
  getSelect,
  selectedElements,
  handleSelect,
}: ISelectableItemProps) {
  const { selectedItems, selectItem, isSelected } = useMediaContext();
  const selectedList = selectedElements ? selectedElements : selectedItems;
  const isEnabled = getSelect ? getSelect : isSelected;

  const getSelectBtnClassName = (_id: string) => {
    return isEnabled(_id)
      ? `text-purple-950 left-1 top-1 bg-white rounded-full block`
      : `text-white ${
          selectedList.length > 0
            ? "opacity-60"
            : "opacity-40 lg:opacity-0 group-hover/item:opacity-60 group-hover/item:hover:opacity-100"
        }`;
  };
  const getSelectButtonIcon = (_id: string) => {
    if (selectedList.length > 0 && !isEnabled(_id)) {
      return generateIcon(
        BsCircle,
        "text-[16px] scale-[1.35] box-shadow-[0 0 0px 1px #fff inset]",
      );
    }

    return generateIcon(BsCheckCircleFill, "text-[16px] scale-[1.35]");
  };

  if (!isSelectable) {
    return <div className="relative group bg-gray-200">{children}</div>;
  }

  return (
    <div className={`relative group/item bg-gray-200 transition-all ${
      isEnabled(id) ? "p-[6px]" : ""
    }`}>
      <span
        className="absolute top-[2px] left-[2px] z-30 cursor-pointer p-3 rounded-full"
        onClick={() => (handleSelect ? handleSelect() : selectItem(id))}
      >
        <span className={getSelectBtnClassName(id)} title="Kijelölés">
          {getSelectButtonIcon(id)}
        </span>
      </span>

      <div className="overflow-hidden">
        {children}
      </div>
    </div>
  );
}